<ngb-alert *ngIf="!staticAlertClosed"
           [dismissible]="true"
           [type]="alert.type"
           (close)="closeAlert()">
  <strong>{{alert.title}}</strong> {{alert.message}}
</ngb-alert>
